export const getUrlWithQueryParams = (url: string, queryParams: Record<string, string>): string => {
  const searchParams = new URLSearchParams(queryParams);
  return `${url}?${searchParams.toString()}`;
};
